import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import 'styles/tables.css';
import { DEFAULT_PAGE_SIZE } from '../../CONST';

const normalize = (value) => {
  const sanitizedValue = value.toString().toLowerCase();
  return sanitizedValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

const filterCaseInsensitive = (filter, row) => {
  const id = filter.pivotId || filter.id;
  const cellValue = row[id];

  if (cellValue === undefined || cellValue === null) {
    return false;
  }

  return normalize(cellValue).includes(normalize(filter.value));
};

const ClientSideTable = ({
  className,
  columns,
  data,
  loading,
  style,
  tableRef,
  showBorders,
  defaultFilterMethod = filterCaseInsensitive,
  pageSize = DEFAULT_PAGE_SIZE,
  filterable = true,
}) => (
  <ReactTable
    className={`-highlight ${className || ''}`}
    loadingText="Cargando..."
    pageSize={pageSize}
    defaultPageSize={pageSize}
    showPagination={data.length > pageSize}
    minRows={1}
    pageText="Página"
    previousText="Anterior"
    nextText="Siguiente"
    noDataText="Sin resultados"
    rowsText="Filas"
    multiSort={false}
    showPageSizeOptions={false}
    ref={tableRef}
    data={data}
    loading={loading}
    columns={columns}
    resizable={false}
    filterable={filterable}
    style={style}
    defaultFilterMethod={defaultFilterMethod}
    getTheadProps={() => ({
      style: {
        background: '#EFEFEF',
      }})
    }
    getTheadThProps={() => ({
      style: {
        border: showBorders ? undefined : 'none',
      }})
    }
    getTrGroupProps={() => ({
      style: {
        border: showBorders ? undefined : 'none',
        borderBottom: '1px solid #CCCCCC',
      }})
    }
    getTdProps={() => ({
      style: {
        border: showBorders ? undefined : 'none'
      },
    })}
    getTableProps={() => ({
      style: { overflowX: 'scroll' },
    })}
  />
);

ClientSideTable.propTypes = [];

export default ClientSideTable;
